import {InputGroup, Form} from "react-bootstrap";
import {Search} from "react-bootstrap-icons";

export interface ResourcesSearchInputProps {
  /** Current search query value (controlled). */
  query: string;
  /** Called with the new query string on every keystroke. */
  setQuery: (val: string) => void;
}

/**
 * Pill-shaped search input used by the Resources and Guides overview pages.
 *
 * Fully controlled — owns no internal state. Pair with
 * {@link useResourcesFiltersAndSort} to feed `query` / `setQuery`.
 */
export default function ResourcesSearchInput({ query, setQuery }: ResourcesSearchInputProps) {
  return (
    <InputGroup className="mb-4 bg-white rounded-pill shadow-sm mx-auto" style={{ maxWidth: 600 }}>
      <InputGroup.Text>
        <Search />
      </InputGroup.Text>
      <Form.Control
        placeholder="Search title or keywords…"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
    </InputGroup>
  );
}
